module.exports = __webpack_public_path__ + "static/media/overpass-semibold-italic.e244fb96.woff";